export default "__VITE_ASSET__DLgHONxR__"